import React from 'react';
import { useReportConfiguration } from 'components/reporting/sidebar/ConfiguredReport';

function AxisTitle({ width, orientation, children }) {
  const { get } = useReportConfiguration();
  const titleStyle = get(`${orientation}AxisTitleFormat`);

  return (
    <span
      style={{
        width,
        ...titleStyle,
      }}
      className={`axis__title axis__title--${orientation}`}
    >
      {children}
    </span>
  );
}

export default AxisTitle;
